import { CreateJobReviewArgs } from '@dinosband/bv-main-client'
import { JobReview } from '@dinosband/bv-main-schema/dist/types'

import { JobReviewSubscriber } from '../../subscriber'
import { DataCenter_StoreType } from '../abstract'
import { JOB_REVIEW_ADDED } from './const'

export class MyJobReviews extends DataCenter_StoreType<number, JobReview> { // <JobReview.id, JobReview>

  _subscriber?: JobReviewSubscriber

  async init () {
    this._subscriber = new JobReviewSubscriber({ mainStore: this.mainStore }, (value) => {
      this.onJobReviewUpdated(value)
    })
    await this._subscriber.start()
  }

  cleanup () {
    super.cleanup()
    this._subscriber?.cleanup()
  }

  async createJobReview (args: CreateJobReviewArgs): Promise<JobReview | undefined> {
    return await this.mainStore.createJobReview(args)
  }

  private onJobReviewUpdated (value: JobReview) {
    this.set(value.id, value)
    this.pubsub.publish(JOB_REVIEW_ADDED, value)
  }

}